// third-party
import { merge } from 'lodash';

// project import
import Badge from './Badge';
import Button from './Button';
import CardContent from './CardContent';
import Checkbox from './Checkbox';
import Chip from './Chip';
import IconButton from './IconButton';
import LinearProgress from './LinearProgress';
import Link from './Link';
import ListItemIcon from './ListItemIcon';
import Tab from './Tab';
import Tabs from './Tabs';
import Typography from './Typography';
import Paper from './Paper';
import Autocomplete from './Autocomplete';
import Card from './Card';
import CssBaseline from './CssBaseline'
import Input from './Input';
import Lists from './Lists';

// ==============================|| OVERRIDES - MAIN ||============================== //

export default function ComponentsOverrides(theme) {
  return merge(
    Button(theme),
    Badge(theme),
    CardContent(),
    Checkbox(theme),
    Chip(theme),
    IconButton(theme),
    LinearProgress(theme),
    Link(theme),
    ListItemIcon(),
    Tab(theme),
    Tabs(theme),
    Typography(theme),
    Paper(theme),
    Autocomplete(theme),
    Card(theme),
    CssBaseline(theme),
    Input(theme),
    Lists(theme)
  );
}
